// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"Dashboard-module__dashboardContainer___ushR_","cardContainer":"Dashboard-module__cardContainer___1FkC2"};